import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import BarLoader from "react-spinners/BarLoader";
import { Image } from "hesus-ui-kit";
import chevronBottom from "@icons/chevron/bottom.svg";
import SellingPriceAction from "../SellingPriceAction";
import AddEditSellingPrice from "../../../AddEditSellingPrice";
import {
  addSpace,
  renderPriceWithCurrency,
  renderPriceWithCurrencyWithoutUnit,
} from "@utils/utils";
import { ColumnButton } from "@utils/extra-style";

import {
  HeaderWrapper,
  HeaderWrapperTable,
  Title,
  SolutionContainer,
  GrayDarkerSpan,
  GrayDarkerServiceSpan,
  GraySpan,
  Separator,
  SellingPriceLabel,
  HeaderText,
  ServiceSection,
} from "./EnquirySellingPrice.styled";

import {
  FlexRow,
  GridRow,
  NoEnquiry,
  MarginDiv,
} from "../../SellingPricesList.styled";
import "../../SellingPricesList.scss";

const EnquirySellingPrice = (props) => {
  const {
    t,
    sellingPriceData,
    onRefreshData,
    page,
    updateRefeshStatus,
    enquiryData,
    loading,
    requestId,
    selectedSolutionIds,
  } = props;

  const [currentSellingPrice, setCurrentSellingPrice] = useState([]);
  const [displaySolution, setDisplaySolution] = useState(true);

  const [isAddSolutionPopupVisible, setAddSolutionPopupVisible] =
    useState(false);

  const onSellingViewClose = () => {
    setAddSolutionPopupVisible(false);
  };

  const onSellingPriceNameClick = (data) => {
    setCurrentSellingPrice(data);
    setAddSolutionPopupVisible(true);
  };

  const displayToggle = () => {
    setDisplaySolution(!displaySolution);
  };

  return (
    <>
      {page !== "enquiryView" && (
        <HeaderWrapper backgroundColor="#008395">
          <FlexRow>
            <Image
              src={chevronBottom}
              alt={t("ENQUIRY_ACTION_TOOLTIP_EDIT")}
              title={t("ENQUIRY_ACTION_TOOLTIP_EDIT")}
              className="selling-price-list__image-enquiry-icon"
              onClick={displayToggle}
            />
            <Title>{t("ENQUIRY_SELLING_PRICES")}</Title>
          </FlexRow>
        </HeaderWrapper>
      )}

      <SolutionContainer display={displaySolution ? "block" : "none"}>
        {(sellingPriceData === null ||
          sellingPriceData?.length === "" ||
          sellingPriceData?.length === 0) && (
          <GridRow column="1fr">
            <NoEnquiry>{t("ENQUIRY_NO_SELLING_PRICES")}</NoEnquiry>
          </GridRow>
        )}
        <GridRow gap="0rem">
          {page === "enquiryView" && (
            <HeaderWrapperTable backgroundColor="#008395">
              <GridRow column="41% 1fr 1fr 1fr 1fr 1fr">
                <HeaderText>{t("ENQUIRY_SELLING_PRICES")}</HeaderText>
                <HeaderText textAlign="center">{t("QUANTITY")}</HeaderText>
                <HeaderText textAlign="center">
                  {t("SELLING_PRICE_ITEM_PRICE")}
                </HeaderText>
                <HeaderText textAlign="right">
                  {t("SELLING_PRICE_ITEM_TOTAL")}
                </HeaderText>
                <HeaderText textAlign="right">
                  {t("SELLING_PRICE_ITEM_MARGIN")}
                </HeaderText>
                <HeaderText textAlign="center">{t("ACTIONS")}</HeaderText>
              </GridRow>
            </HeaderWrapperTable>
          )}
          {loading && (
            <MarginDiv marginTop="30px">
              <BarLoader width="100%" color="#1bace4" />
            </MarginDiv>
          )}
          {sellingPriceData?.length !== "" &&
            ((page === "enquiryView" &&
              parseInt(sellingPriceData[0]?.requestId, 10) ===
                parseInt(requestId, 10)) ||
              page === "enquiryList") &&
            sellingPriceData?.map((data, index) => {
              return (
                <ServiceSection
                  key={"sellingPriceList_" + index}
                  color={data.isActive === 1 ? "#fff" : "#ededed"}
                >
                  {index !== 0 && (
                    <Separator
                      marginTop={page === "enquiryView" ? "0px" : "7px"}
                    ></Separator>
                  )}

                  <GridRow column="100%" gap="0rem" marginTop="10px">
                    <SellingPriceLabel
                      onClick={() => onSellingPriceNameClick(data)}
                      color={data.isActive === 1 ? "#0a4986" : "#767676"}
                    >
                      {"#" + data?.id}
                      {data?.hesusCatalog?.label
                        ? " - " + data?.hesusCatalog?.label
                        : ""}
                      {data?.label ? " - " + data?.label : ""}
                    </SellingPriceLabel>
                  </GridRow>
                  {data.services?.length !== "" &&
                    data.services?.map((service, indexService) => {
                      return (
                        <GridRow
                          column={
                            page === "enquiryView"
                              ? "41% 1fr 1fr 1fr 1fr 1fr"
                              : "41% 1fr 1fr 1fr 1fr"
                          }
                          marginBottom={indexService === 0 ? "1px" : "3px"}
                          key={
                            "sellingPriceServiceList_" + index + indexService
                          }
                        >
                          <MarginDiv marginLeft="30px">
                            <GrayDarkerServiceSpan
                              weight="700"
                              color={
                                data.isActive === 1 ? "#474747" : "#767676"
                              }
                            >
                              {service?.hesusService?.name}
                            </GrayDarkerServiceSpan>
                            <GraySpan>
                              {service?.hesusService?.needProduct
                                ? " - " + service?.product?.name
                                : ""}
                              {service?.hesusService?.needTransport
                                ? " - " + service?.transportType?.name
                                : ""}
                            </GraySpan>
                          </MarginDiv>
                          <GraySpan textAlign="center">
                            {addSpace(service.quantity) + " " + t(service.unit)}
                          </GraySpan>
                          <GraySpan textAlign="center">
                            {renderPriceWithCurrency(
                              addSpace(service?.unitPrice),
                              t(service?.unit),
                              data?.currency?.symbol,
                              data?.currency?.position
                            )}
                          </GraySpan>

                          <GrayDarkerSpan
                            color={data.isActive === 1 ? "#474747" : "#767676"}
                            textAlign="right"
                          >
                            {renderPriceWithCurrencyWithoutUnit(
                              addSpace(service?.totalPrice),
                              data?.currency?.symbol,
                              data?.currency?.position
                            )}
                          </GrayDarkerSpan>
                          {page === "enquiryView" && (
                            <>
                              <GraySpan textAlign="right">
                                {service.marginRate + " %"}
                              </GraySpan>

                              <div>
                                {indexService === 0 && (
                                  <SellingPriceAction
                                    id={data.id}
                                    enquiryData={enquiryData}
                                    isActive={data.isActive}
                                    onRefreshData={onRefreshData}
                                    updateRefeshStatus={updateRefeshStatus}
                                    currentSellingPrice={data}
                                    selectedSolutionsIds={
                                      selectedSolutionIds[data.id]
                                    }
                                  />
                                )}
                              </div>
                            </>
                          )}
                          {page !== "enquiryView" && indexService === 0 && (
                            <ColumnButton
                              border="#3EBBB9"
                              background="#3EBBB9"
                              marginRight="10px"
                            >
                              <span>{data.totalMargin + " %"}</span>
                            </ColumnButton>
                          )}
                        </GridRow>
                      );
                    })}
                </ServiceSection>
              );
            })}
        </GridRow>
        {isAddSolutionPopupVisible && (
          <AddEditSellingPrice
            onClose={onSellingViewClose}
            id={currentSellingPrice.id}
            sellingPriceData={currentSellingPrice}
            enquiryId={currentSellingPrice.requestId}
            enquiryData={enquiryData}
            countryId={parseInt(enquiryData?.site?.platformCountry.id, 10)}
            onRefreshData={onRefreshData}
            selectedSolutionsIds={selectedSolutionIds[currentSellingPrice.id]}
            isEditMode
          />
        )}
      </SolutionContainer>
    </>
  );
};

EnquirySellingPrice.propTypes = {
  t: PropTypes.func.isRequired,
  page: PropTypes.string,
};

EnquirySellingPrice.defaultProps = {
  page: "enquiryView",
};
export default withTranslation()(EnquirySellingPrice);
